<template>
  <span
    class="tab"
    :class="{active}"
  >
    <slot></slot>
  </span>
</template>

<script>

export default {
  props: {
    active: Boolean,
  },
}

</script>


<style scoped>

.tab {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-radius: 1px;
  padding: 6px;
  cursor: pointer;
}

.tab:hover, .tab.active {
  background-color: rgba(50, 202, 210, .08);
}

.tab + .tab {
  margin-top: 12px;
}

svg {
  color: #9A9A9A;
}

.tab.active {
  font-weight: bold;
  color: #0081c7;
}

.tab.active svg {
  color: #0081c7;
}

</style>
